<template>
  <v-dialog
    v-model="value"
    fullscreen
    hide-overlay
    transition="slide-x-reverse-transition"
  >
    <v-card class="no-scroll">
      <v-toolbar dark fixed color="primary" class="">
        <v-btn icon rigth @click="$emit('input', false)">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-toolbar-title
          ><span class="font-weight-regular title"
            >Points de vente participants</span
          ></v-toolbar-title
        >
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container grid-list-lg fluid px-0 class="flex-div flex-column">
        <div class="container-pos pt-3">
          <v-layout row wrap justify-center pt-5 mt-2 class="head-pos">
            <v-flex xs12 class="flex-div flex-column" pt-0 mx-3>
              <div class="flex-div align-center">
                <v-icon small class="mr-2">my_location</v-icon
                ><span><b>Ma localisation actuelle :</b></span>
              </div>
              <span v-if="loading" class="font-weight-light">
                Localisation en cours ...
                <v-progress-circular
                  width="1"
                  size="8"
                  indeterminate
                  color="primary"
                />
              </span>
              <span v-else-if="geoLocation.address" class="font-weight-light">{{
                geoLocation.address
              }}</span>
              <span v-else class="font-weight-light"
                >Veuillez vous géolocaliser pour obtenir votre adresse</span
              >
            </v-flex>
            <v-flex xs12 pb-0>
              <v-text-field
                solo
                label="Rechercher un point de vente"
                append-icon="search"
                v-model="searchField"
                hide-details
                class="relative"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <div v-if="loading" class="w-100 flex-div justify-center">
            <v-progress-circular
              class="my-4"
              width="2"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div v-else class="list-in">
            <!-- Pos -->
            <div v-for="(pos, index) in searchPos" class="one-pos" :key="index">
              <pos-card
                v-if="anyPointOfSale"
                :pos="pos"
                :origin="geoLocation.coords"
              />
              <p v-else>Aucun point de ventes ...</p>
            </div>
          </div>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import PosCard from '@/components/PosCard.vue'

export default {
  components: {
    PosCard
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    pos: {
      type: Array,
      required: true
    },
    geoLocation: {
      require: true
    }
  },
  data () {
    return {
      searchField: ''
    }
  },
  computed: {
    anyPointOfSale () {
      return this.pos.length > 0
    },
    searchPos () {
      return this.pos.filter(e =>
        e.name.match(new RegExp(this.searchField, 'i'))
      )
    }
  }
}
</script>
